<template>
  <div class="bg-white">
    <img :src="src" alt="Map" width="400" height="224">
  </div>
</template>

<script>
import { useRuntimeConfig } from 'nuxt/app'

export default {
  props: {
    venue: { type: Object, required: true },
  },

  computed: {
    markerUrl () {
      return encodeURIComponent('https://www.tripexpert.com/images/marker@2x.png')
    },

    src () {
      return `https://api.mapbox.com/styles/v1/tripexpertweb/ckcdpjifn06ru1impw321xsqi/static/url-${this.markerUrl}(${this.venue.longitude},${this.venue.latitude})/${this.venue.longitude},${this.venue.latitude},14/400x224@2x?access_token=${useRuntimeConfig().public.mapboxApiToken}`
    },
  },
}
</script>
